import axios from "../../utils/AxiosUtils";
import _ from 'lodash';
import MessageUtils from "../../utils/MessageUtils";
import * as i18n from "i18next";
import { LOADING } from "../types";

export const createTicket = (state, successCallback, errorCallback) => {
    return (dispatch, getState) => {

        if (state.attachments.length > 0) {
            createAttachments(dispatch, getState, state, successCallback, errorCallback)
        } else {
            doCreateTicket(dispatch, getState, state, successCallback, false)
        }
    }
};

const doCreateTicket = (dispatch, getState, state, successCallback, availableAttachments, attachmentsData) => {

    dispatch({ type: LOADING, payload: true });

    const attachmentsIds = (availableAttachments) ? attachmentsData : [];

    const ticketRequestData = {
        subject: state.subject,
        body: state.body,
        attachmentIds: attachmentsIds
    }

    const userId = getState().user.id && getState().user.id !== -1 ? getState().user.id : localStorage.getItem('id');

    const url = `/user/${userId}/create-ticket`;

    axios().post(url, ticketRequestData)
        .then(response => doCreateTicketSuccess(dispatch, response, successCallback))
        .catch(error => MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:createTicketActions.createTicketFailure')));
}


const doCreateTicketSuccess = (dispatch, response, successCallback) => {
    dispatch({ type: LOADING, payload: false });

    MessageUtils.dispatchSuccessMessage(dispatch, i18n.t('actions:createTicketActions.createTicketSuccess'));

    if (successCallback) {
        successCallback();
    }
}


const createAttachments = (dispatch, getState, state, successCallback, errorCallback) => {

    dispatch({ type: LOADING, payload: true });

    let files = state.attachments;

    let filesObject = {};

    for (let i = 0; i < files.length; i++) {
        let index = i + 1;
        filesObject['file' + index] = _.reduce(files[i], function (value, key) {
            return value
        });
    }

    const formData = new FormData();
    Object.keys(filesObject).map((fileName, value) => {
        const file = _.reduce(files[value], function (value, key) {
            return value
        });

        formData.append(fileName, file);
    });

    const url = `/user/create-attachments`;

    axios().post(url, formData)
        .then(response => createAttachmentsSuccess(dispatch, getState, state, response, successCallback))
        .catch(error => createAttachmentsFailure(dispatch, error, errorCallback))
}


const createAttachmentsSuccess = (dispatch, getState, state, response, successCallback) => {
    doCreateTicket(dispatch, getState, state, successCallback, true, response.data.data);
}

const createAttachmentsFailure = (dispatch, error, errorCallback) => {
    dispatch({ type: LOADING, payload: false });
    MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:createTicketActions.createTicketFailure'));

    if (errorCallback) {
        errorCallback();
    }
}






// WEBPACK FOOTER //
// ./src/actions/support/CreateTicketActions.js